var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3498 2.63965C13.3498 2.22543 13.014 1.88965 12.5998 1.88965C12.1856 1.88965 11.8498 2.22543 11.8498 2.63965V3.98961C10.831 3.0706 9.48105 2.51035 7.9998 2.51035C5.35312 2.51035 3.12587 4.29788 2.45583 6.73016C2.34583 7.1295 2.58038 7.54241 2.97971 7.65242C3.37905 7.76242 3.79196 7.52787 3.90197 7.12854C4.39737 5.33019 6.04541 4.01035 7.9998 4.01035C9.08632 4.01035 10.0781 4.41793 10.8301 5.08965H9.3998C8.98559 5.08965 8.6498 5.42543 8.6498 5.83965C8.6498 6.25386 8.98559 6.58965 9.3998 6.58965H12.3621C12.3717 6.58983 12.3812 6.58983 12.3908 6.58965H12.5998C13.014 6.58965 13.3498 6.25386 13.3498 5.83965V2.63965ZM12.0976 9.30116C11.6022 11.0995 9.95418 12.4193 7.9998 12.4193C6.91328 12.4193 5.92148 12.0118 5.16952 11.34H6.5998C7.01401 11.34 7.3498 11.0043 7.3498 10.59C7.3498 10.1758 7.01401 9.84005 6.5998 9.84005L3.63747 9.84005C3.62792 9.83986 3.61835 9.83986 3.60878 9.84005H3.3998C2.98559 9.84005 2.6498 10.1758 2.6498 10.59L2.6498 13.79C2.6498 14.2043 2.98558 14.54 3.3998 14.54C3.81401 14.54 4.1498 14.2043 4.1498 13.79L4.1498 12.4401C5.16863 13.3591 6.51855 13.9193 7.9998 13.9193C10.6465 13.9193 12.8737 12.1318 13.5438 9.69953C13.6538 9.30019 13.4192 8.88729 13.0199 8.77728C12.6205 8.66727 12.2076 8.90182 12.0976 9.30116Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.76269d36e715f4b9af93966474e80a87.svg";
export { ForwardRef as ReactComponent };